const forEachPolyfill = () => {
  // eslint-disable-next-line no-undef
  NodeList.prototype.forEach = Array.prototype.forEach
}

export default forEachPolyfill
